export default __webpack_public_path__ + "static/og-tac-0c6780e9988b50f77aa6c26ccee57923.jpg";